'use strict';

wbApp.factory('membershipSvc', ['$resource', 'repositorySvc',
    function ($resource, repositorySvc) {

        var Membership = $resource('/Api/Membership/Get/:id', {}, {
            'query': { method: 'GET', isArray: true },
            'getValid': { method: 'GET', url: '/Api/Membership/GetValid', isArray: true },
            'save': { method: 'POST', url: '/Api/Membership/Save' },
            'delete': { method: 'POST', url: '/Api/Membership/Delete' }
        });

        var memberships;

        var lastNow;
        var lastValidMembership;

        function getAllAsync(refresh) {
            if (!memberships || refresh) {
                memberships = repositorySvc.get(Membership, {});
            }
            return memberships;
        }

        function getAllValidAsync(now, refresh) {

            var normalizedNow = moment(now).startOf('day');

            if (!normalizedNow.isSame(lastNow) || !lastValidMembership || refresh) {
                lastNow = normalizedNow;
                lastValidMembership = repositorySvc.customGet('getValid', Membership, { now: normalizedNow.toDate() });
            }

            return lastValidMembership;
        }

        function save(data, successCallback, errorCallback) {
            repositorySvc.save(
                Membership,        // $resource
                memberships,       // collection
                data,              // entity
                successCallback,
                errorCallback);
        }

        function remove(data, successCallback, errorCallback) {
            repositorySvc.remove(
                Membership,        // $resource
                memberships,       // collection
                data,              // entity
                successCallback, 
                errorCallback);
        }

        return {
            getAllAsync: getAllAsync,
            getAllValidAsync: getAllValidAsync,
            save: save,
            remove: remove
        }

    }]);